import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { CheckCircle } from "lucide-react";

export function SupportModal({
  open,
  onOpenChange,
  supportForm,
  setSupportForm,
  supportLoading,
  ticketSubmitted,
  setTicketSubmitted,
  handleSupportSubmit
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Submit Support Request</DialogTitle>
          <DialogDescription>We'll get back to you within 24 hours</DialogDescription>
        </DialogHeader>
        {ticketSubmitted ? (
          <div className="text-center py-6">
            <CheckCircle className="h-12 w-12 text-green-600 mx-auto mb-4" />
            <p className="font-medium">Request Submitted!</p>
            <p className="text-sm text-gray-500">Ticket ID: {ticketSubmitted}</p>
            <Button onClick={() => { onOpenChange(false); setTicketSubmitted(null); setSupportForm({subject: "", description: ""}); }} className="mt-4">
              Close
            </Button>
          </div>
        ) : (
          <div className="space-y-4">
            <div>
              <label className="text-sm font-medium">Subject</label>
              <Input value={supportForm.subject} onChange={(e) => setSupportForm({...supportForm, subject: e.target.value})} placeholder="Brief description" />
            </div>
            <div>
              <label className="text-sm font-medium">Description</label>
              <Textarea value={supportForm.description} onChange={(e) => setSupportForm({...supportForm, description: e.target.value})} rows={4} placeholder="Provide details..." />
            </div>
            <Button onClick={handleSupportSubmit} disabled={supportLoading} className="w-full">
              {supportLoading ? "Submitting..." : "Submit Request"}
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
